// extracted by mini-css-extract-plugin
export default {"searchInput":"CloudFoldersControlBar_searchInput__YGjVZ"};